import axiosToken from "../../api/axiosClient";
import { buildQueryString } from "../../utils/reportUtils";

class CommissionReportService {
  async getSummary(params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(
        `/reports/commissions/summary${queryString}`,
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  async getDetails(params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(
        `/reports/commissions/details${queryString}`,
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  async getEmployeeReport(employeeId, params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(
        `/reports/commissions/employee/${employeeId}${queryString}`,
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  _handleError(error) {
    return {
      message: error.response?.data?.error || "Erreur commissions",
      status: error.response?.status,
    };
  }
}

export default new CommissionReportService();
